import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import { NAVIGATE_ADMIN, NAVIGATE_AUTH, NAVIGATE_MODULE } from '../constant';

const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));
const UserRoute = lazy(() => import('./UserRoute'));
const CommonDrawerComponent = lazy(() => import('../components/drawer'));


const AppRoute = () => {
    return (
        <>
            <Suspense fallback={<LoaderText />}>
                <Routes>
                    <Route path={`${NAVIGATE_AUTH.AUTH}/*`} element={<AuthRoute />}></Route>
                    <Route path={`${NAVIGATE_MODULE.USER}/*`} element={<UserRoute />}></Route>
                    <Route path={`${NAVIGATE_ADMIN.ADMIN_USER}/*`} element={<AdminRoute />}></Route>
                    <Route path='/' element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route>
                    <Route path={`${NAVIGATE_AUTH.LOGIN}`} element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route>
                    <Route path='*' element={<GuestRoute />}></Route>
                </Routes>
            </Suspense>
            <CommonDrawerComponent />
        </>
    )
}

export default AppRoute;